import React from 'react';
import _ from 'lodash';
import validator from 'validator';
import '../../../assets/scss/authenticator.scss';
import AuthenticatorController from '../../../controllers/authenticator';
import { ReactComponent as LoadingLight } from '../../../assets/svg/loading-light.svg';
import { ReactComponent as VisiblePassword } from '../../../assets/svg/password-visible.svg';
import { ReactComponent as InvisiblePassword } from '../../../assets/svg/password-invisible.svg';

import InputNew from '../../components/global/inputNew';
import ButtonNew from '../../components/global/buttonNew';

//import ReCAPTCHA from 'react-google-recaptcha';

import Cookies from 'universal-cookie';
import { withRouter } from '../../../services/withRoute';
const cookies = new Cookies();

class UserLogin extends AuthenticatorController {
	constructor(props) {
		super(props);
		this.state = {
			userName: '',
			isUserNameEmail: true,
			userNameError: false,
			passwordError: false,
			userNameErrorMessage: '',
			dailCode: '+91',
			errorMessage: '',
			isSubmitting: false,
			showPassword: false,
			isCaptchaToken: false,
			passwordErrorMessage: '',
			show2fa: false,
			authenticatorAppCode: '',
			authenticatorAppCodeError: false,
			authenticatorAppCodeErrorMessage: '',
		};
	}

	timeOut = null;

	componentDidMount = () => {};

	componentWillUnmount = () => {
		if (this.timeOut) {
			clearTimeout(this.timeOut);
		}
	};

	onLoadRecaptcha() {}

	expiredRecaptcha() {
		if (this.captchaDemo) {
			this.captchaDemo.reset();
		}
	}

	handleVerifyCallback = (recaptchaToken) => {
		if (recaptchaToken) {
			this.setState({
				isCaptchaToken: true,
			});
		}
	};

	validateInput = (type) => {
		if (type === 'userName') {
			if (this.state.userName === '') {
				this.setState({
					userNameError: true,
					userNameErrorMessage: 'Email required',
				});
			} else if (!validator.isEmail(this.state.userName)) {
				this.setState({
					userNameError: true,
					userNameErrorMessage: 'Invalid email address',
				});
			}
		} else if (type === 'password') {
			if (this.state.password === '') {
				this.setState({
					passwordError: true,
					passwordErrorMessage: 'Password required',
				});
			}
		}
	};

	onInputChange = (e) => {
		let errorName = e.target.name + 'Error';
		let errorMessage = e.target.name + 'ErrorMessage';

		this.setState(
			{
				[e.target.name]: e.target.value,
				[errorName]: false,
				[errorMessage]: '',
				errorMessage: '',
			},
			() => {
				clearTimeout(this.timeOut);
				this.timeOut = setTimeout(() => {
					this.validateInput(e.target.name);
				}, 500);
			},
		);
	};
	onInputChange2FA = (e) => {
		const re = /^[0-9\b]+$/;

		if (e.target.value === '' || re.test(e.target.value)) {
			this.setState({ [e.target.name]: e.target.value });
		}
	};
	handleSubmit = async () => {
		if (
			this.state.userName !== '' &&
			this.state.password != '' &&
			this.state.userNameError === false &&
			this.state.passwordError === false &&
			//this.state.isCaptchaToken === true &&
			validator.isEmail(this.state.userName)
		) {
			this.setState({ isSubmitting: true });

			//let response = await this.userLoginWithPassword();
			let response = await this.get2FADetails();

			//this.setState({ isSubmitting: false });
		} else {
			if (this.state.userName === '') {
				this.setState({
					userNameError: true,
					userNameErrorMessage: 'Required Field',
				});
			}
			if (this.state.password === '') {
				this.setState({
					passwordError: true,
					passwordErrorMessage: 'Required Field',
				});
			}
			if (!validator.isEmail(this.state.userName)) {
				this.setState({
					userNameError: true,
					userNameErrorMessage: 'Invalid email address',
				});
			}
		}
	};

	onKeyDown(event) {
		if (event.keyCode === 13 && !this.isDisabled()) {
			if (!this.state.isSubmitting) this.handleSubmit();
		}
	}

	isDisabled = () => {
		if (
			//this.state.isCaptchaToken === false ||
			this.state.userName === '' ||
			this.state.userName === null ||
			this.state.password === '' ||
			this.state.password === null ||
			!validator.isEmail(this.state.userName)
		) {
			return true;
		} else {
			return false;
		}
	};
	isDisabledBtn = () => {
		if (
			//this.state.isCaptchaToken === false ||
			this.state.authenticatorAppCode === '' ||
			this.state.authenticatorAppCode === null
		) {
			return true;
		} else {
			return false;
		}
	};
	handleSubmit2FaCode = async () => {
		if (
			this.state.authenticatorAppCode !== '' &&
			this.state.authenticatorAppCodeError === false
		) {
			await this.userLoginWithPassword(
				this.state.userName,
				this.state.password,
				this.state.authenticatorAppCode,
			);
		} else {
			if (this.state.authenticatorAppCode === '') {
				this.setState({
					authenticatorAppCodeError: true,
					authenticatorAppCodeErrorMessage: 'Required Field',
				});
			}
		}
	};
	render() {
		return (
			<div className="sl-container">
				<div className="sl-right">
					<div className="sl-header-body-container">
						<div className={'sl-header-container'}>
							<div className="header-title-container">
								<span className="header-title-left"></span>
								<span className="header-title-middle">LOVE</span>
								<span className="header-title-right">CO</span>
								<span className="header-title-divider">|</span>
								<span className="header-title-vendors">Vendors</span>
							</div>
						</div>
						{this.state.show2fa ? (
							<div
								className="sl-body sl-signup-body-container"
								style={{ gap: '24px' }}
							>
								<div className="sl-signup-body-top" style={{ gap: '6px' }}>
									{/* <div className="sl-google-sign-btn">
								<span className="google-icn">
									<GoogleIcon />
								</span>
								<span className="title">Continue with Google</span>
							</div>
							<div className="sl-divider-container">
								<hr />
								<span>Or</span>
								<hr />
							</div> */}
									<label className={'two-factor-authentication-title'}>
										Two Factor Authentication (2FA)
									</label>
									<b className="two-factor-authentication-desc">
										Please enter your authenticator app code or secret code
										below
									</b>
									<InputNew
										type={'text'}
										value={this.state.authenticatorAppCode}
										onChange={(e) => this.onInputChange2FA(e)}
										autoFocus={true}
										name="authenticatorAppCode"
										isInputError={this.state.authenticatorAppCodeError}
										errorMessage={this.state.authenticatorAppCodeErrorMessage}
										placeholder="Authenticator App Code"
									/>
								</div>

								<ButtonNew
									title="Login"
									isDisabled={this.isDisabledBtn()}
									handleClick={() => {
										if (!this.state.isSubmitting) this.handleSubmit2FaCode();
									}}
									isLoading={this.state.isSubmitting}
								/>
								<p className={'error-message'}>{this.state.errorMessage}</p>
							</div>
						) : (
							<div
								className="sl-body sl-signup-body-container"
								style={{ gap: '24px' }}
							>
								<div className="sl-signup-body-top" style={{ gap: '24px' }}>
									{/* <div className="sl-google-sign-btn">
								<span className="google-icn">
									<GoogleIcon />
								</span>
								<span className="title">Continue with Google</span>
							</div>
							<div className="sl-divider-container">
								<hr />
								<span>Or</span>
								<hr />
							</div> */}
									<InputNew
										type={'text'}
										value={this.state.userName}
										onChange={(e) => this.onInputChange(e)}
										autoFocus={true}
										name="userName"
										isInputError={this.state.userNameError}
										errorMessage={this.state.userNameErrorMessage}
										placeholder="Email"
									/>
									<InputNew
										type={this.state.showPassword ? 'text' : 'password'}
										value={this.state.password}
										onChange={(e) => this.onInputChange(e)}
										name="password"
										isInputError={this.state.passwordError}
										errorMessage={this.state.passwordErrorMessage}
										placeholder="Password"
										onKeyDown={(e) => this.onKeyDown(e)}
										isIconLast
										image={
											this.state.showPassword ? (
												<VisiblePassword />
											) : (
												<InvisiblePassword />
											)
										}
										onClickImage={() =>
											this.setState({
												showPassword: !this.state.showPassword,
											})
										}
									/>
								</div>

								<ButtonNew
									title="Login"
									isDisabled={this.isDisabled()}
									handleClick={() => {
										if (!this.state.isSubmitting) this.handleSubmit();
									}}
									isLoading={this.state.isSubmitting}
								/>
								<p className={'error-message'}>{this.state.errorMessage}</p>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(UserLogin);
